module.exports = __webpack_public_path__ + "static/media/RoadLeftRight.95b741f5.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/tiles/RoadLeftRight.png
// module id = 194
// module chunks = 0